document.addEventListener("DOMContentLoaded", function () {
  const importFileForm = document.querySelector(".js-import-file-form");
  const importFileInput = document.querySelector("#js-import-file-input");
  if (importFileForm && importFileInput) {
    importFileInput.addEventListener("input", () => {
      importFileForm.submit();
    });
  }
});
